module.exports = __webpack_public_path__ + "img/green_lock.38b8a88b.gif";